module.exports = __webpack_public_path__ + "media/images/design/sizeS-wrap-b7d82c77eb4c54d81a24775387b09b1e.png";